
import widgetsList from "@/genWidgets.js";

export default function applyWidgets() {
    const widgetElements = document.querySelectorAll('[data-widget]');

    widgetElements.forEach(async (element) => {
        const widgetName = element.dataset["widget"];
        
        if (!widgetName) {
            throw new Error("No widget name");
        }

        let widgetNames;
        try {
            widgetNames = JSON.parse(widgetName);
        } catch {
            widgetNames = [ widgetName ];
        }

        widgetNames.forEach(async function (widgetName) {
        const widgetImport = widgetsList[widgetName];

        if (!widgetImport) {
            throw new Error("Unknown widget: " + widgetName, element);
        }

        const widgetLoader = await widgetImport();

        if (!widgetLoader) {
            throw new Error("Can't load widget: " + widgetName);
        }

        const widget = widgetLoader.default;

        if (!widget) {
            return;
        }

        const data = Object.assign({}, element.dataset);
        Object.keys(data).forEach(function(key) {
            const value = data[key];
            if (typeof value === 'string' || value instanceof String) {
                try {
                    data[key] = JSON.parse(value);
                } catch {}
            }
        });

        widget(element, data);

        element.classList.remove("widget-not-initialized");
        element.classList.add("widget-initialized");
        });
    });
}
